/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["hu",[["de.","du."]],u,[["V","H","K","Sz","Cs","P","Sz"],["V","H","K","Sze","Cs","P","Szo"],["vasÃ¡rnap","hÃ©tfÅ","kedd","szerda","csÃ¼tÃ¶rtÃ¶k","pÃ©ntek","szombat"],["V","H","K","Sze","Cs","P","Szo"]],u,[["J","F","M","Ã","M","J","J","A","Sz","O","N","D"],["jan.","febr.","mÃ¡rc.","Ã¡pr.","mÃ¡j.","jÃºn.","jÃºl.","aug.","szept.","okt.","nov.","dec."],["januÃ¡r","februÃ¡r","mÃ¡rcius","Ã¡prilis","mÃ¡jus","jÃºnius","jÃºlius","augusztus","szeptember","oktÃ³ber","november","december"]],u,[["ie.","isz."],["i. e.","i. sz."],["Krisztus elÅtt","idÅszÃ¡mÃ­tÃ¡sunk szerint"]],1,[6,0],["y. MM. dd.","y. MMM d.","y. MMMM d.","y. MMMM d., EEEE"],["H:mm","H:mm:ss","H:mm:ss z","H:mm:ss zzzz"],["{1} {0}",u,u,u],[",","Â ",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","#,##0.00Â Â¤","#E0"],"HUF","Ft","magyar forint",{"AUD":[u,"$"],"BRL":[u,"R$"],"BYN":[u,"Ñ."],"CAD":[u,"$"],"CNY":[u,"Â¥"],"EUR":[u,"â¬"],"GBP":[u,"Â£"],"HKD":[u,"$"],"HUF":["Ft"],"ILS":[u,"âª"],"INR":[u,"â¹"],"KRW":[u,"â©"],"MXN":[u,"$"],"NZD":[u,"$"],"PHP":[u,"â±"],"TWD":[u,"NT$"],"USD":[u,"$"],"VND":[u,"â«"],"XCD":[u,"$"]},"ltr", plural];
